import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ParentBottomTabBar } from '@/components/ui/ParentBottomTabBar';
import { GlobalHeader } from '@/components/GlobalHeader';
import { SubscriptionTiers } from '@/components/SubscriptionTiers';
import { useChildren } from '@/services/parents';

export function ParentSubscriptionPage() {
  const { t } = useTranslation();
  const { data: children, isLoading } = useChildren();
  const [selectedChildId, setSelectedChildId] = useState('');

  useEffect(() => {
    if (!selectedChildId && children && children.length > 0) {
      setSelectedChildId(children[0]?.child_id ?? '');
    }
  }, [children, selectedChildId]);

  const selectedChild = children?.find((c) => c.child_id === selectedChildId);

  return (
    <div className="page-center">
      <div className="phone-mockup">
        <GlobalHeader />
        <div className="app-content" style={{ paddingBottom: '24px' }}>

          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-dark)', margin: '0 0 24px' }}>
            {t('parent_subscription.title')}
          </h1>

          {isLoading ? (
            <div className="loading-skeleton" style={{ height: '280px', borderRadius: '12px' }} />
          ) : !children || children.length === 0 ? (
            <div className="card">
              <p style={{ margin: '0 0 16px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                {t('parent_subscription.no_children')}
              </p>
              <Link to="/parent/add-child" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
                {t('parent_subscription.add_child_cta')}
              </Link>
            </div>
          ) : (
            <>
              {children.length > 1 && (
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: '4px' }}>
                    {t('parent_subscription.select_child')}
                  </label>
                  <select
                    className="input"
                    value={selectedChildId}
                    onChange={(e) => setSelectedChildId(e.target.value)}
                  >
                    {children.map((c) => (
                      <option key={c.child_id} value={c.child_id}>
                        {c.display_name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <SubscriptionTiers countryCode={selectedChild?.country} />
            </>
          )}

        </div>

        <ParentBottomTabBar activeTab="Subscription" />
      </div>
    </div>
  );
}
